import { render, staticRenderFns } from "./ShunyiAuthPage.vue?vue&type=template&id=0591ce15&scoped=true"
import script from "./ShunyiAuthPage.vue?vue&type=script&lang=js"
export * from "./ShunyiAuthPage.vue?vue&type=script&lang=js"
import style0 from "./ShunyiAuthPage.vue?vue&type=style&index=0&id=0591ce15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591ce15",
  null
  
)

export default component.exports